export default function global_download(
  b64: string,
  name: string,
  marked: boolean
) {
  const byteCharacters = atob(b64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: 'application/octet-stream' });
  const binaryUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = binaryUrl;
  if (marked == false) {
    link.download = name;
  } else {
    link.download = 'MarkedFields ' + name;
  }

  link.click();

  URL.revokeObjectURL(binaryUrl);
}
